import React from 'react';
import Statements from './Statements';

function Home() {
  return (
    <main data-testid="home-container">
      <Statements />
    </main>
  );
}

export default Home;
